import { DateTime } from 'luxon';

import { PENDING_CONTRACT_CONFIRMATION_STATUSES } from '../constants';
import { ContractConfirmation } from '../models';

/**
 * Returns the date of the oldest day that still needs to be confirmed within the given contract
 * confirmation. A contract confirmation can span several weeks, so its `dateFrom` is only used as a
 * fallback when none of its days carries a pending status.
 */
export const getOldestPendingContractConfirmationDate = (
  contractConfirmation: ContractConfirmation | null
): DateTime | null => {
  if (!contractConfirmation) {
    return null;
  }

  const pendingDates = (contractConfirmation.workTime ?? [])
    .filter(({ status }) => PENDING_CONTRACT_CONFIRMATION_STATUSES.includes(status))
    .map(({ date }) => DateTime.fromISO(date))
    .filter(date => date.isValid);

  if (pendingDates.length) {
    return DateTime.min(...pendingDates) ?? null;
  }

  const dateFrom = DateTime.fromISO(contractConfirmation.dateFrom);

  return dateFrom.isValid ? dateFrom : null;
};
